/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { MixedValue } from "./types";

export function isString(value: MixedValue): value is string {
  return typeof value === "string";
}
